module.exports = __webpack_public_path__ + "static/img/company-logo.bea34c1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/company-logo.svg
// module id = tLNH
// module chunks = 46